// Lightweight client-side perf logger for route load + auth latency.
// Logs to console with a stable prefix so you can filter in DevTools:
//   filter: [perf]
//
// No network calls, no deps — safe to import anywhere on the client.

const PREFIX = "[perf]";

function now(): number {
  return typeof performance !== "undefined" ? performance.now() : Date.now();
}

export function logRouteLoad(route: string, startedAt: number) {
  if (typeof window === "undefined") return;
  const ms = Math.round(now() - startedAt);
  // eslint-disable-next-line no-console
  console.info(`${PREFIX} route "${route}" rendered in ${ms}ms`);
}

export function logAuthLatency(label: string, startedAt: number) {
  if (typeof window === "undefined") return;
  const ms = Math.round(now() - startedAt);
  // eslint-disable-next-line no-console
  console.info(`${PREFIX} auth "${label}" took ${ms}ms`);
}

export function perfNow(): number {
  return now();
}
